"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = require("../styles/theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrapperDiv = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "eghs12a0",
  label: "WrapperDiv"
})("font-family:", _theme.fonts.sans.family, ";border:1px solid ", _theme.colors.red.primary, ";background-color:rgba(255,0,0,0.2);padding:15px;color:red;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL2ludGVybmFsL0NvbXBvbmVudEVycm9yLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLZ0MiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvaW50ZXJuYWwvQ29tcG9uZW50RXJyb3IuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xyXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xyXG5pbXBvcnQgeyBmb250cywgY29sb3JzIH0gZnJvbSAnLi4vc3R5bGVzL3RoZW1lJztcclxuXHJcbmNvbnN0IFdyYXBwZXJEaXYgPSBzdHlsZWQoJ2RpdicpYFxyXG4gIGZvbnQtZmFtaWx5OiAke2ZvbnRzLnNhbnMuZmFtaWx5fTtcclxuICBib3JkZXI6IDFweCBzb2xpZCAke2NvbG9ycy5yZWQucHJpbWFyeX07XHJcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgyNTUsIDAsIDAsIDAuMik7XHJcbiAgcGFkZGluZzogMTVweDtcclxuICBjb2xvcjogcmVkO1xyXG5gO1xyXG5cclxuY29uc3QgRXJyb3JEaXNwbGF5ID0gKHByb3BzKSA9PiB7XHJcbiAgY29uc3QgeyBjaGlsZHJlbiB9ID0gcHJvcHM7XHJcbiAgcmV0dXJuIChcclxuICAgIDxXcmFwcGVyRGl2PlxyXG4gICAgICA8c3Bhbj5Db21wb25lbnQgRXJyb3I6IDwvc3Bhbj5cclxuICAgICAge2NoaWxkcmVufVxyXG4gICAgPC9XcmFwcGVyRGl2PlxyXG4gICk7XHJcbn07XHJcblxyXG5FcnJvckRpc3BsYXkucHJvcFR5cGVzID0ge1xyXG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMub25lT2ZUeXBlKFtQcm9wVHlwZXMuZWxlbWVudCwgUHJvcFR5cGVzLnN0cmluZ10pLmlzUmVxdWlyZWRcclxufTtcclxuXHJcbmV4cG9ydCBkZWZhdWx0IEVycm9yRGlzcGxheTtcclxuIl19 */"));

var ErrorDisplay = function ErrorDisplay(props) {
  var children = props.children;
  return /*#__PURE__*/_react.default.createElement(WrapperDiv, null, /*#__PURE__*/_react.default.createElement("span", null, "Component Error: "), children);
};

ErrorDisplay.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired
};
var _default = ErrorDisplay;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/internal/ComponentError.js
// module id = 344
// module chunks = 0 15 16 17 18